module.exports = __webpack_public_path__ + "img/yo-screen-4.84a2ef02.webp";